// Add a class to the body to customize the focus styles triggered by the keyboard
window.addEventListener('DOMContentLoaded', () => {
  document.body.addEventListener('mousedown', () => document.body.classList.add('using-mouse'));
  document.body.addEventListener('keydown', () => document.body.classList.remove('using-mouse'));
});
